"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathFn = void 0;
var clone_deep_1 = __importDefault(require("clone-deep"));
var symbol_1 = require("./symbol");
var isPath_1 = require("./isPath");
var pathFn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    args = args.reduce(function (acc, x) {
        if ((0, isPath_1.isPath)(x)) {
            acc = acc.concat(x.__expand__());
        }
        else {
            acc.push(x);
        }
        return acc;
    }, []);
    var current = (0, clone_deep_1.default)(args);
    var path = function () {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        newArgs = newArgs.reduce(function (acc, x) {
            if ((0, isPath_1.isPath)(x)) {
                acc = acc.concat(x.__expand__());
            }
            else {
                acc.push(x);
            }
            return acc;
        }, []);
        var result = current.concat(newArgs);
        return exports.pathFn.apply(void 0, result);
    };
    Object.defineProperty(path, "__symbol__", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: symbol_1.PathSymbol,
    });
    Object.defineProperty(path, "__expand__", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function () { return current; },
    });
    return path;
};
exports.pathFn = pathFn;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aEZuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BhdGgvcGF0aEZuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDBEQUErQjtBQUMvQixtQ0FBc0M7QUFDdEMsbUNBQWtDO0FBRTNCLElBQU0sTUFBTSxHQUFHO0lBQUMsY0FBYztTQUFkLFVBQWMsRUFBZCxxQkFBYyxFQUFkLElBQWM7UUFBZCx5QkFBYzs7SUFDbkMsSUFBSSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsVUFBQyxHQUFHLEVBQUUsQ0FBQztRQUN4QixJQUFJLElBQUEsZUFBTSxFQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ2IsR0FBRyxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLFVBQVUsRUFBRSxDQUFDLENBQUM7U0FDbEM7YUFBTTtZQUNMLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDYjtRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ1AsSUFBTSxPQUFPLEdBQUcsSUFBQSxvQkFBSyxFQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVCLElBQU0sSUFBSSxHQUFHO1FBQUMsaUJBQWlCO2FBQWpCLFVBQWlCLEVBQWpCLHFCQUFpQixFQUFqQixJQUFpQjtZQUFqQiw0QkFBaUI7O1FBQzdCLE9BQU8sR0FBRyxPQUFPLENBQUMsTUFBTSxDQUFDLFVBQUMsR0FBRyxFQUFFLENBQUM7WUFDOUIsSUFBSSxJQUFBLGVBQU0sRUFBQyxDQUFDLENBQUMsRUFBRTtnQkFDYixHQUFHLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsVUFBVSxFQUFFLENBQUMsQ0FBQzthQUNsQztpQkFBTTtnQkFDTCxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO2FBQ2I7WUFDRCxPQUFPLEdBQUcsQ0FBQztRQUNiLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNQLElBQU0sTUFBTSxHQUFHLE9BQU8sQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDdkMsT0FBTyxjQUFNLGVBQUksTUFBTSxFQUFFO0lBQzNCLENBQUMsQ0FBQztJQUVGLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLFlBQVksRUFBRTtRQUN4QyxVQUFVLEVBQUUsS0FBSztRQUNqQixZQUFZLEVBQUUsS0FBSztRQUNuQixRQUFRLEVBQUUsS0FBSztRQUNmLEtBQUssRUFBRSxtQkFBVTtLQUNsQixDQUFDLENBQUM7SUFFSCxNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSxZQUFZLEVBQUU7UUFDeEMsVUFBVSxFQUFFLEtBQUs7UUFDakIsWUFBWSxFQUFFLEtBQUs7UUFDbkIsUUFBUSxFQUFFLEtBQUs7UUFDZixLQUFLLEVBQUUsY0FBTSxPQUFBLE9BQU8sRUFBUCxDQUFPO0tBQ3JCLENBQUMsQ0FBQztJQUVILE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQyxDQUFDO0FBdENXLFFBQUEsTUFBTSxVQXNDakIifQ==